import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import moment from "moment";
import { getCPVoltageHistory } from "@/fetch/fetchApi";
import RefreshGrid from "@/utils/refreshGrid";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class CPVoltageHistory extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      formConfig: null,
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {}

  init() {
    this.setState({
      tableConfig: {
        tableKey: "CPVoltageHistoryTable",
        tableColumns: [
          {
            name: "上传时间",
            key: "dateTime",
            colType: "textCol",
            render: (text) => {
              return moment(text).format("YYYY-MM-DD HH:mm:ss");
            },
          },
          {
            name: "CP电压",
            key: "cpVoltage",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}v`;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
          stubId: this.props.stubId,
          dateTime: moment().format("YYYY-MM-DD"),
        },
        dataApi: getCPVoltageHistory,
        autoRefresh: true, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "date",
          dateType: "pickDate",
          placeholder: "请选择日期",
          param: {
            name: "date",
            type: "object",
          },
          labelName: "日期",
          required: true,
          defaultValue: moment(),
          disabledDate: (current) => {
            let flag = false;
            if (current < moment().subtract(3, "month").endOf("day")) {
              flag = true;
            }

            if (current && current > moment(new Date()).endOf("day")) {
              flag = true;
            }
            return flag;
          },
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.internationalization.btn1, // '查询'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: true, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "CPVoltageHistoryTable",
    };

    return formConfig;
  };

  fetchApi = (param) => {
    param.date = moment(param.date).format("YYYYMMDD");
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "dbmHistoryTable", param);
    }
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(CPVoltageHistory);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/CPVoltageHistory.js